var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.548,
    height: 21.549,
    viewBox: "0 0 21.548 21.549",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1",
    transform: "translate(-19.34 -61.48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M23.68,70.812A18.033,18.033,0,0,0,31.568,78.7L34.2,76.057a1.2,1.2,0,0,1,1.216-.293,13.64,13.64,0,0,0,4.258.683h.02a1.193,1.193,0,0,1,1.193,1.193v4.2A1.194,1.194,0,0,1,39.7,83.029H39.69a20.353,20.353,0,0,1-20.35-20.35h0v0a1.2,1.2,0,0,1,1.2-1.2h4.194a1.193,1.193,0,0,1,1.193,1.193v.02a13.661,13.661,0,0,0,.682,4.259,1.181,1.181,0,0,1,.058.366,1.2,1.2,0,0,1-.35.848L23.68,70.812Z",
    fill: "#CEA663"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFPhone);
export default __webpack_public_path__ + "static/media/f-phone.790f541d5cc092b34d11b36ad9338557.svg";
export { ForwardRef as ReactComponent };